import React from "react";
import {useTranslation} from "react-i18next";
import {Send} from "lucide-react";


const ExportConfirmPopup = ({handleClosePopup}) => {
    const {t} = useTranslation("activite");
    return (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-10">
            <div className="bg-white dark:bg-gray-800 p-6 rounded-md w-1/3 shadow-lg text-center" style={{marginLeft: "150px"}}>
                <Send
                    className="text-gray-600 dark:text-gray-400 mb-4"
                    size={60}
                    style={{display: 'block', margin: '0 auto', marginBottom: '20px'}}
                />

                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">{t("exportPopup.exportInProgress")}</h2>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
                    {t("exportPopup.exportInProgressBody")}
                </p>
                <p className="text-sm text-primary mb-4">tzoukamine@gmail.com</p>
                <div
                    className="w-full py-2 px-4 rounded-md text-center"
                    style={{backgroundColor: '#4DB6AC'}}
                >
                    <button
                        onClick={handleClosePopup}
                        className="text-white w-full"
                    >
                        {t("exportPopup.understood")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExportConfirmPopup;
